export const GET_REPORT_DATA_REQUEST = 'REPORT/GET_REPORT_DATA_REQUEST';
export const GET_REPORT_DATA_SUCCESS = 'REPORT/GET_REPORT_DATA_SUCCESS';
export const GET_REPORT_DATA_FAILURE = 'REPORT/GET_REPORT_DATA_FAILURE';
export const UPDATE_REPORT_DATA = 'REPORT/UPDATE_REPORT_DATA';
